// Modules
import React from 'react'
import { useHistory } from 'react-router-dom'

// Application
import { Analytics, ROUTES_PATH } from 'constants/index'
import { useAnalytics, useActiveCIPOrphanHook } from 'hooks'

// Components
import { Header, TemplateContainer } from 'components'
import { NewPassword, NewPasswordInitial } from 'components/Presenters/NewPassword'

export const MDMCIPCreatePassword: React.VFC = () => {
    const history = useHistory()
    const { hasMounted, biologicalSex, cpf, setPassword } = useActiveCIPOrphanHook()
    const shouldRedirect = !cpf || !biologicalSex

    // evento funil
    useAnalytics(Analytics.ActivateAccountCipOrphan.MdmAccountPassword, !shouldRedirect)

    if (!hasMounted) {
        return null
    }

    if (shouldRedirect) {
        history.push(ROUTES_PATH.SIGN_UP_REGISTER_ACTIVATION_CPF)
        return null
    }

    const handleSubmit = async ({ password }: NewPasswordInitial) => {
        await setPassword(password)
        history.push(ROUTES_PATH.SIGN_UP_MDM_CIP_SELECT_CONTACT)
    }

    return (
        <TemplateContainer>
            <Header subtitle="Inclua os requisitos listados abaixo para criar uma senha segura:" title="Crie uma senha" />
            <NewPassword handleSubmit={handleSubmit} initialValues={{ password: '', confirmPassword: '' }} />
        </TemplateContainer>
    )
}
